import { render, staticRenderFns } from "./RegistreChangement.vue?vue&type=template&id=8dfe494c"
import script from "./RegistreChangement.vue?vue&type=script&lang=js"
export * from "./RegistreChangement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports